import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCAyjeebU0Y9LngHHmdY62glJbQ_o4htRk",
  authDomain: "bentobox-web-app.firebaseapp.com",
  projectId: "bentobox-web-app",
  storageBucket: "bentobox-web-app.firebasestorage.app",
  messagingSenderId: "282329002180",
  appId: "1:282329002180:web:9a1ff69e2a1a96d79fd991",
};

const app = initializeApp(firebaseConfig);

// Enable persistent local cache with multi-tab support
// Previously fetched data loads instantly from IndexedDB on return visits
// Fresh data is fetched silently in the background
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});
